document.addEventListener('click', function (e) {
  const button = e.target.closest('#load-more-services');
  if (!button) {
    return;
  }
  e.preventDefault();

  if (button.disabled) {
    return;
  }

  const container = document.getElementById('service-items');
  if (!container) {
    return;
  }

  const page = parseInt(button.dataset.page, 10);
  const max = parseInt(button.dataset.max, 10);
  const cat = button.dataset.cat || '';
  const search = button.dataset.search || '';
  const sort = button.dataset.sort || '';
  const dashboard = button.dataset.dashboard || '';
  let postsPerPage = 18;
  if (button.dataset.posts_per_page) {
    postsPerPage = parseInt(button.dataset.posts_per_page, 10);
  }
  const cardColumn = button.dataset.column || '';
  const currentLang = (window.dvTranslation && window.dvTranslation.currentLang) || document.documentElement.getAttribute('lang') || 'en';

  const formData = new FormData();
  formData.append('action', 'load_more_services');
  formData.append('page', page);
  formData.append('cat', cat);
  formData.append('search', search);
  formData.append('sort', sort);
  formData.append('dashboard', dashboard);
  formData.append('postsPerPage', postsPerPage);
  formData.append('cardColumn', cardColumn);
  formData.append('lang', currentLang);

  const originalHtml = button.innerHTML;
  button.disabled = true;

  let ajaxUrl = (window.ajax_callback_data && window.ajax_callback_data.ajax_url) || '/wp-admin/admin-ajax.php';
  try {
    const parsed = new URL(ajaxUrl, window.location.origin);
    if (parsed.host !== window.location.host) {
      ajaxUrl = window.location.origin + parsed.pathname + parsed.search;
    }
  } catch (err) {
    ajaxUrl = ajaxUrl.replace(/^https?:\/\/[^\/]+/, '');
  }

  const xhr = new XMLHttpRequest();
  xhr.open('POST', ajaxUrl, true);

  xhr.onload = function () {
    button.disabled = false;
    button.innerHTML = originalHtml;
    if (xhr.status === 200 && xhr.responseText.trim() !== '') {
      container.insertAdjacentHTML('beforeend', xhr.responseText);

      button.dataset.page = page + 1;

      if (page >= max) {
        button.remove();
      }
    } else if (page >= max || xhr.status === 200) {
      button.remove();
    }
  };

  xhr.onerror = function () {
    button.disabled = false;
    button.innerHTML = originalHtml;
  };

  xhr.send(formData);
});

document.addEventListener('click', function (e) {
  const sortIcon = e.target.closest('#sort-toggle');
  if (!sortIcon) {
    return;
  }
  e.preventDefault();

  const current = sortIcon.dataset.current;
  let nextSort = 'asc';
  if (current === 'asc') {
    nextSort = 'desc';
  }

  const url = new URL(window.location.href);
  url.searchParams.set('sort', nextSort);

  // Keep current category and search term intact
  window.location.href = url.toString();
});

